export const pushGtmDataLayer = (payload: { [key: string]: any }): void => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
};
